import { createApi } from '@reduxjs/toolkit/query/react';

import { AUTH_API_URL } from 'api/APIBase';
import { handleRTKQueryError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

const TagType = {
    SUPPLIER_USER_NAME_MAP: 'SUPPLIER_USER_NAME_MAP',
} as const;

export const authApi = createApi({
    baseQuery: getBaseQuery(AUTH_API_URL),
    reducerPath: 'authApi',
    tagTypes: Object.values(TagType),
    endpoints: (build) => ({
        getSupplierUserNameMap: build.query<Record<string, string>, void>({
            query: () => `profile/supplier/name_map`,
            providesTags: [TagType.SUPPLIER_USER_NAME_MAP],
            transformErrorResponse: handleRTKQueryError('An error occurred retrieving user names.'),
        }),
    }),
});

export const { useGetSupplierUserNameMapQuery } = authApi;
